export function tagColors(tag: Pick<DatabaseTable<"tags">, "color">) {
  return {
    bgColor: hexToHSL(tag.color, { luminance: 90, saturation: 75 }),
    textColor: hexToHSL(tag.color, { luminance: 20, saturation: 75 }),
    bdColor: hexToHSL(tag.color, { luminance: 85, saturation: 50 }),
  };
}
